// =====================================================================
// encounterService (PME Sprint 2 / S51) — chamadas axios pra API de consultas (SOAP).
//
// Endpoints (isAuth no backend; multi-tenant por companyId do JWT):
//   GET  /patients/:patientId/encounters     -> { encounters }
//   POST /patients/:patientId/encounters      -> consulta criada
//   GET  /patients/:patientId/appointments    -> { appointments } (integração agenda, read-only)
//   GET  /encounters/:id                       -> detalhe (+audit view)
//   PUT  /encounters/:id                        -> atualizada (só enquanto 'open')
//   POST /encounters/:id/sign                   -> assinada (open -> signed)
//   GET  /encounter-professionals               -> { professionals } (dropdown)
// =====================================================================
import api from "./api";

export const listEncounters = async (patientId) => {
  const { data } = await api.get(`/patients/${patientId}/encounters`);
  return data; // { encounters }
};

export const listPatientAppointments = async (patientId) => {
  const { data } = await api.get(`/patients/${patientId}/appointments`);
  return data; // { appointments }
};

export const getEncounter = async (id) => {
  const { data } = await api.get(`/encounters/${id}`);
  return data;
};

export const createEncounter = async (patientId, payload) => {
  const { data } = await api.post(`/patients/${patientId}/encounters`, payload);
  return data;
};

export const updateEncounter = async (id, payload) => {
  const { data } = await api.put(`/encounters/${id}`, payload);
  return data;
};

export const signEncounter = async (id) => {
  const { data } = await api.post(`/encounters/${id}/sign`);
  return data;
};

// Exclui consulta — só funciona se ainda estiver 'open' (backend rejeita assinada).
export const deleteEncounter = async (id) => {
  await api.delete(`/encounters/${id}`);
};

export const listEncounterProfessionals = async () => {
  const { data } = await api.get(`/encounter-professionals`);
  return data; // { professionals }
};

export const ENCOUNTER_TYPES = [
  { value: "first_visit", label: "Primeira consulta" },
  { value: "return", label: "Retorno" },
  { value: "emergency", label: "Urgência" },
  { value: "surgery", label: "Cirurgia" }
];

export const ENCOUNTER_TYPE_LABELS = ENCOUNTER_TYPES.reduce((acc, t) => {
  acc[t.value] = t.label;
  return acc;
}, {});

export const ENCOUNTER_STATUS_LABELS = {
  open: "Em aberto",
  signed: "Assinada",
  reviewed: "Revisada"
};

// Traduz o erro do backend EHR (AppError -> { error: "ERR_..." }) numa mensagem amigável.
export const encounterErrorMessage = (err) => {
  const code = err && err.response && err.response.data && err.response.data.error;
  const map = {
    ERR_ENCOUNTER_NOT_FOUND: "Consulta não encontrada.",
    ERR_ENCOUNTER_LOCKED: "Consulta já assinada — não pode ser editada ou excluída.",
    ERR_ENCOUNTER_ALREADY_SIGNED: "Esta consulta já está assinada.",
    ERR_PATIENT_NOT_FOUND: "Paciente não encontrado."
  };
  if (code && map[code]) return map[code];
  if (code && typeof code === "string" && !code.startsWith("ERR_")) return code;
  return "Não foi possível concluir a operação. Tente novamente.";
};
